import $ from 'jquery';
import 'bootstrap';
import GOB from './GOB';
import Tablesaw from 'tablesaw';
import 'datatables.net-bs4';
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = $;
    window.Tablesaw = Tablesaw;
    window.GOB = GOB;
} catch (e) { }

window.GIWebViewJS_onInstalled = function () {
    window.GOB.initGIWebView();
};
if (document.body.classList.contains('gi-webview')) {
    window.GOB.initGIWebView();
}

require('jquery-bracket/dist/jquery.bracket.min.js');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
